<script lang="ts">
	import ArrowUp from './arrowUp.svg.svelte';
	interface Props {
		className?: string;
	}

	let { className = 'h-full w-full' }: Props = $props();
</script>

<ArrowUp {className} rotate />
